<template>
    <v-list-tile ripple 
      v-bind:key="agentInfos.status"
      :id="'agent_' + agentInfos.agentID"
      class="itemsListeAgent"
    >
      <wz-avatar :src="agentInfos.avatar" :username="agentInfos.agentName" size="38px"></wz-avatar>
      <div class="statusAgent" :class="agentInfos.status"></div>
      
      <v-list-tile-content class="wz_truncate listeAgentName">
        <v-list-tile-title>{{agentInfos.agentName}}</v-list-tile-title>
        <v-list-tile-sub-title>{{agentInfos.jobAgent}}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-badge color="green" overlay>
        <span class="caption" v-if="sessionsChatAgent.length" slot="badge">{{sessionsChatAgent.length}}</span>
      </v-badge>
    </v-list-tile>
</template>

<style>
.offline {background-color: #ef4f4f;}
.online {background-color: #1cde7b;}
.busy {background-color: #e6c628;}
.statusAgent { 
  height: calc(100% - 8px);
  min-width: 2px;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: 4px;
}
.itemsListeAgent{padding-right: 8px;}
</style>

<script>
// import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'
import { DOMAINE } from '../../constants'

export default {
  props: ['datasAgent'], // Les donnés du parent (trafic.vue)
  data () {
    return {
    }
  },

  mounted () {
  },

  methods: {
  },

  watch: {
  },

  computed: {
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_StoreWatcheeBox', ['listeChatAgent']),
    agentInfos () {
      // retourne la bonne url de l'image avatar
      var avatarURL = ''
      if (process.env.NODE_ENV === 'development') {
        avatarURL = `${DOMAINE}/dev/media/user/small/${this.datasAgent[7]}`
      } else {
        avatarURL = `${DOMAINE}/media/user/small/${this.datasAgent[7]}`
      }
      return {
        // donnés remontées par redis via nodejs
        'roomName': this.datasAgent[0],
        'agentName': this.datasAgent[1],
        'agentID': this.datasAgent[2],
        'status': this.datasAgent[3],
        'socketID': this.datasAgent[4],
        'conversations': this.datasAgent[5],
        'jobAgent': this.datasAgent[6],
        'avatar': avatarURL, // url de l'avatar
        'siteID': this.datasAgent[9],
        'entrepriseID': this.datasAgent[10],
        'licences': this.datasAgent[11],
        'chatSessions': this.datasAgent[12],
        'deviceAgent': this.datasAgent[13],
        'tokenFB': this.datasAgent[14],
        'pageFB': this.datasAgent[15],
        'focusAgent': this.datasAgent[16],
        'focusSessionChat': this.datasAgent[17],
        'priority': this.datasAgent[18],
        'keywords': this.datasAgent[19],
        'cobrowsingSessionActive': this.datasAgent[20]
      }
    },
    sessionsChatAgent () {
      // filtre les chat avec le bon id agent
      // console.log('listeChatAgent', this.listeChatAgent)
      // console.log('this.datasAgent[2]', this.datasAgent[2])
      // return _.filter(this.listeChatAgent, [3, this.datasAgent[2]])
      return this.listeChatAgent.filter(chat => chat[3] === this.datasAgent[2])
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/watcheebox/WzWatcheeboxAgent.vue